
import { BacnetUnitsId, BacnetObjectTypes, BacnetReliability } from './types'

const UnitsDict = {
    // temps
    [BacnetUnitsId.DEGREES_CELSIUS]: "°C",
    [BacnetUnitsId.DEGREES_KELVIN]: "°K",
    [BacnetUnitsId.DELTA_DEGREES_KELVIN]: "dK",
    [BacnetUnitsId.DEGREES_FAHRENHEIT]: "°F",
    // mass & volume flow
    [BacnetUnitsId.CUBIC_METERS_PER_HOUR]: "m³/h",
    [BacnetUnitsId.LITERS_PER_MINUTE]: "l/min",
    [BacnetUnitsId.LITERS_PER_SECOND]: "l/sec",
    [BacnetUnitsId.US_GALLONS_PER_MINUTE]: "gal/min",
    [BacnetUnitsId.US_GALLONS_PER_HOUR]: "gal/h",
    [BacnetUnitsId.TON_HOURS]: "ton*h",
    [BacnetUnitsId.LITERS_PER_HOUR]: "l/h" ,
    // pressure
    [BacnetUnitsId.PASCALS]: "pa",
    [BacnetUnitsId.BARS]: "bar",
    [BacnetUnitsId.KILOPASCALS]: "kpa",
    [BacnetUnitsId.POUNDS_FORCE_PER_SQUARE_INCH]: "PSI",
    [BacnetUnitsId.MILLIBARS]: "mbar",
    // time
    [BacnetUnitsId.SECONDS]: "sec",
    [BacnetUnitsId.MINUTES]: "min",
    [BacnetUnitsId.HOURS]: "h",
    [BacnetUnitsId.YEARS]: "years",
    // energy
    [BacnetUnitsId.WATTS]: "W",
    [BacnetUnitsId.WATT_HOURS]: "Wh",
    [BacnetUnitsId.KILOWATTS]: "kW",
    [BacnetUnitsId.KILOWATT_HOURS]: "kWh",
    [BacnetUnitsId.MEGAWATTS]: "MW",
    [BacnetUnitsId.MEGAWATT_HOURS]: "MWh",
    [BacnetUnitsId.VOLTS]: "V",
    [BacnetUnitsId.MEGAJOULES]: "MJ",
    [BacnetUnitsId.KILO_BTUS_PER_HOUR]: "KBtu/h",
    [BacnetUnitsId.KILO_BTUS]: "KBtu",
    [BacnetUnitsId.TONS_REFRIGERATION]: "TR",
    [BacnetUnitsId.AMPERES]: "A",
    [BacnetUnitsId.HERTZ]: "Hz",
    [BacnetUnitsId.OHMS]: "Ω" , 
    [BacnetUnitsId.MILLIAMPERES]: "mA" , 
    [BacnetUnitsId.VOLT_AMPERES]: "VA",
    [BacnetUnitsId.KILOVOLT_AMPERES]: "kVA",
    [BacnetUnitsId.VOLT_AMPERES_REACTIVE]: "VAR",
    [BacnetUnitsId.KILOVOLT_AMPERES_REACTIVE]: "kVAR",
    [BacnetUnitsId.MILLIVOLTS]: "mV",
    // others
    [BacnetUnitsId.PERCENT]: "%",
    [BacnetUnitsId.PERCENT_RELATIVE_HUMIDITY]: "%RH",
    [BacnetUnitsId.CUBIC_METERS]: "m³",
    [BacnetUnitsId.DEGREES_ANGULAR]: "°",
    [BacnetUnitsId.PARTS_PER_MILLION]: "ppm",
    [BacnetUnitsId.REVOLUTIONS_PER_MINUTE]: "rpm",
    [BacnetUnitsId.METERS_PER_SECOND]: "m/s",
    [BacnetUnitsId.NO_UNITS]: "",
    [BacnetUnitsId.DEGREES_PHASE]: "°",
    [BacnetUnitsId.LUXES]: "lx",
    [BacnetUnitsId.KILOMETERS_PER_HOUR]: "km/h",
    [BacnetUnitsId.MILES_PER_HOUR]: "mph",

};

export function GetUnitsString(unit: BacnetUnitsId): string {
    if (isNaN(unit))
        return "";
    const unitStr = UnitsDict[unit];
    if (unitStr !== undefined) return unitStr;

    const uid = BacnetUnitsId[unit];
    if ( uid )
        return uid.toString();
    return `unknown ID: '${unit}' `.toString();
}

export function isBinary(type: BacnetObjectTypes): boolean {
    switch (type) {
        case BacnetObjectTypes.BINARY_INPUT:
        case BacnetObjectTypes.BINARY_OUTPUT:
        case BacnetObjectTypes.BINARY_VALUE:
            return true;
        default: return false;
    }
}

export function isInteger(type: BacnetObjectTypes): boolean {
    switch (type) {
        case BacnetObjectTypes.INTEGER_VALUE:
        case BacnetObjectTypes.POSITIVE_INTEGER_VALUE:
            return true;
        default: return false;
    }
}

export function isMultiState(type: BacnetObjectTypes): boolean {
    switch (type) {
        case BacnetObjectTypes.MULTI_STATE_INPUT:
        case BacnetObjectTypes.MULTI_STATE_OUTPUT:
        case BacnetObjectTypes.MULTI_STATE_VALUE:
            return true;
        default: return false;
    }
}

const ReliabilitiesDict = {
    [BacnetReliability.NoFaultDetected]: "No fault detected",
    [BacnetReliability.NoSensor]: "No sensor is connected",
    [BacnetReliability.OverRange]: "Value higher than the normal operating range",
    [BacnetReliability.UnderRange]: "Value lower than the normal operating range",
    [BacnetReliability.OpenLoop]: "Open circuit",
    [BacnetReliability.ShortedLoop]: "Short circuit",
    [BacnetReliability.NoOutput]: "No physical device is connected",
    [BacnetReliability.ConfigurationError]: "Properties are not in a consistent state",
    [BacnetReliability.CommunicationFailure]: "Communication failure",

};

export function getReliabilityString(rel: BacnetReliability): string {
    if (isNaN(rel))
        return "";
    const unitStr = ReliabilitiesDict[rel];
    if (unitStr !== undefined) return unitStr;

    const bacnetReliability = BacnetReliability[rel]
    if (bacnetReliability !== undefined) return bacnetReliability.toString();

    return rel.toString();
}